<template>
  <div class="video-clip-container">
    <!-- 顶部 header -->
    <header>
      <div class="header-content">
        <div class="logo-section">
          <img v-if="theme"
            src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/logo.png" alt="待加载">
          <img v-else src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/dark_logo.png"
            alt="待加载">
        </div>

        <!-- GPU 实时监控 -->
        <gpu-monitor />

        <div class="header-spacer"></div>
        <div class="header-actions">
          <!-- 返回主页按钮 -->
          <div class="home-btn" @click="gohome">
            <span class="iconfont">&#xe8a2;</span>
            <span>返回主页</span>
          </div>
          <!-- 生图记录按钮 -->
          <div class="header-btn" @click="handleGoToImageLog">
            <span class="iconfont">&#xe640;</span>
            <span>生图记录</span>
          </div>
          <!-- 支持与反馈按钮 -->
          <div class="header-btn" @click="handleOpenFeedback">
            <span class="iconfont">&#xe681;</span>
            <span>支持与反馈</span>
          </div>
          <!-- 用户头像 -->
          <div class="user-avatar">
            <img :src="avatar" alt="待加载">
          </div>
        </div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="video-clip-page-wrapper">
    <!-- 左侧精简导航栏 -->
    <div class="slim-sidebar">
      <!-- 中间功能按钮区域 -->
      <div class="sidebar-middle">
        <div class="nav-item" @click="handleScriptClick" title="提示词">
          <svg class="nav-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
            <path d="M661.653927 850.681606l-598.429465 0 L63.224462 166.398798l598.429465 0L661.653927 850.681606zM605.57777 794.633079 605.57777 222.461651 119.313921 222.461651l0 572.172451L605.57777 794.634102" fill="currentColor"></path>
            <path d="M240.774227 366.237195c-15.442714 0-28.009937-12.568247-28.009937-28.051893 0-15.456017 12.567223-28.024264 28.009937-28.024264l252.366751 0c15.496949 0 28.052916 12.568247 28.052916 28.024264 0 15.483646-12.555967 28.051893-28.052916 28.051893L240.774227 366.237195" fill="currentColor"></path>
            <path d="M240.774227 528.002462c-15.442714 0-28.009937-12.56927-28.009937-28.052916 0-15.497972 12.567223-28.05087 28.009937-28.05087l252.366751 0c15.496949 0 28.052916 12.552897 28.052916 28.05087 0 15.482623-12.555967 28.052916-28.052916 28.052916L240.774227 528.002462" fill="currentColor"></path>
            <path d="M240.774227 689.73703c-15.442714 0-28.009937-12.539594-28.009937-28.010961 0-15.495926 12.567223-28.063149 28.009937-28.063149l252.366751 0c15.496949 0 28.052916 12.567223 28.052916 28.063149 0 15.471366-12.555967 28.010961-28.052916 28.010961L240.774227 689.73703" fill="currentColor"></path>
            <path d="M848.279395 867.327728 717.454814 705.59009l0-539.231201 242.974847 0 0 539.231201L848.279395 867.327728zM844.829829 773.906012l59.499116-85.865623L904.328945 222.461651 773.504364 222.461651l0 463.249693L844.829829 773.906012" fill="currentColor"></path>
            <path d="M754.831073 348.274078 754.831073 292.171316 923.055448 292.171316 923.055448 348.274078 754.831073 348.274078Z" fill="currentColor"></path>
          </svg>
          <span class="nav-label">提示词</span>
        </div>
        <div class="nav-item" @click="handleInspirationClick" title="灵感">
          <span class="iconfont">&#xe600;</span>
          <span class="nav-label">灵感</span>
        </div>
      </div>

      <!-- 底部功能按钮区域 -->
      <div class="sidebar-bottom">
        <div class="nav-item" @click="handleShortcutClick" title="快捷键">
          <span class="iconfont">&#xe623;</span>
        </div>
        <div class="nav-item" @click="toggleTheme" title="深色模式">
          <span class="iconfont">{{ theme ? '&#xe61c;' : '&#xe61d;' }}</span>
        </div>
      </div>
    </div>

    <!-- 右侧主内容区域 -->
    <div class="right_menu_assistant">
      <!-- 对话历史区域 -->
      <div class="chat-container" ref="chatContainer">
        <div class="chat-history" v-if="chatHistory.length > 0">
          <div v-for="(message, index) in chatHistory" :key="index"
               :class="['message-item', message.role === 'user' ? 'user-message' : 'ai-message']">
            <!-- 用户消息 -->
            <div v-if="message.role === 'user'" class="message-wrapper">
              <!-- 如果用户上传了视频，在左侧显示缩略图 -->
              <div v-if="message.video" class="message-thumbnails">
                <div class="video-thumbnail">
                  <img v-if="message.videoThumbnail" :src="message.videoThumbnail" alt="视频缩略图" class="thumbnail-img">
                  <span v-else class="iconfont">&#xe684;</span>
                </div>
              </div>
              <div class="message-content">
                <div class="message-text">{{ message.content }}</div>
              </div>
              <div class="message-avatar">
                <img :src="avatar" alt="用户">
              </div>
            </div>

            <!-- AI 消息 -->
            <div v-if="message.role === 'assistant'" class="message-item-column" :class="{ 'split-column': message.isSplit }">
              <div class="message-wrapper">
                <div class="message-avatar ai-avatar">
                  <span class="iconfont">&#xe6a5;</span>
                </div>
                <div class="message-content">
                  <!-- 显示文本内容（进度信息或完成信息） -->
                  <div class="message-text" :class="{ error: message.isError }" v-if="message.content">{{ message.content }}</div>
                  <!-- 批量结果：slot式渲染（每个slot固定位置，状态: loading/done/error） -->
                  <div v-if="message.videoSlots && message.videoSlots.length > 0" class="message-videos" :class="{ 'split-row': message.isSplit }">
                    <div v-for="(slot, slotIndex) in message.videoSlots" :key="slotIndex" :data-slot-index="slotIndex"
                         :class="['result-video-item', slot.status === 'loading' ? 'placeholder-item' : '', slot.status === 'error' ? 'error-item' : '']">
                      <!-- 加载中 -->
                      <div v-if="slot.status === 'loading'" class="placeholder-animation">
                        <video
                          src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/system_start_demo/Delicate%20Moods.mp4"
                          autoplay loop muted playsinline="true"></video>
                      </div>
                      <!-- 生成完成 -->
                      <div v-else-if="slot.status === 'done' && slot.video" class="result-video-wrapper">
                        <video
                          controls
                          preload="auto"
                          class="result-video"
                          :src="slot.video.url"
                          type="video/mp4"
                          @error="handleVideoError($event, slot.video.url)"
                          @loadeddata="onVideoLoaded($event, slot.video.url)"
                          @canplay="onVideoCanPlay($event, slot.video.url)">
                          您的浏览器不支持视频播放
                        </video>
                        <div class="video-error" v-if="videoErrors[slotIndex]">
                          <p>视频加载失败: {{ videoErrors[slotIndex] }}</p>
                          <p>URL: {{ slot.video.url }}</p>
                        </div>
                        <div class="video-actions">
                          <button class="action-btn download-btn" @click="handleDownloadVideo(slot.video)">
                            <span class="iconfont">&#xe693;</span>
                            下载视频
                          </button>
                          <button class="action-btn refill-btn" @click="handleRefillWithVideo(slot.video, message, slotIndex)">
                            <span class="iconfont">&#xe693;</span>
                            一键填入
                          </button>
                          <button class="action-btn material-btn" @click="handleAddToMaterial(slot.video)">
                            <span class="iconfont">&#xe693;</span>
                            加入素材库
                          </button>
                          <button class="action-btn postprocess-btn" @click="handlePostProcess(slot.video)">
                            <span class="iconfont">&#xe693;</span>
                            后期处理
                          </button>
                        </div>
                      </div>
                      <!-- 生成失败 -->
                      <div v-else-if="slot.status === 'error'" class="error-placeholder">
                        <span class="error-icon">✕</span>
                      </div>
                    </div>
                  </div>
                  <!-- 兼容旧的单个结果 -->
                  <div v-else-if="message.resultVideo" class="message-video">
                    <video controls class="result-video">
                      <source :src="message.resultVideo.url" type="video/mp4">
                      您的浏览器不支持视频播放
                    </video>
                    <div class="video-actions">
                      <button class="action-btn download-btn" @click="handleDownloadVideo(message.resultVideo)">
                        <span class="iconfont">&#xe693;</span>
                        下载视频
                      </button>
                      <button class="action-btn refill-btn" @click="handleRefill(index)">
                        <span class="iconfont">&#xe693;</span>
                        一键填入
                      </button>
                    </div>
                  </div>
                  <!-- 失败气泡的按钮组（仅显示重新生成） -->
                  <div v-if="message.isError" class="message-actions">
                    <button class="action-btn regenerate-btn" @click="handleRegenerate(index)">
                      重新生成
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态提示 -->
        <div v-else class="empty-state">
          <div class="empty-icon">&#127916;</div>
          <h3>AI-视频剪辑</h3>
          <p>上传一个视频文件并描述想要提取的片段，AI将自动为你剪辑出匹配的视频段落</p>
        </div>

        <!-- AI 正在输入提示（视频剪辑功能已禁用，进度信息在消息中显示） -->
        <div v-if="false && aiTyping" class="typing-indicator">
          <div class="typing-avatar">
            <span class="iconfont">&#xe6a5;</span>
          </div>
          <div class="typing-content">
            <div class="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div v-if="currentProgress" class="progress-text">大约完成：{{ currentProgress }}%</div>
          </div>
        </div>
      </div>
    </div>
    </div>

    <!-- 底部输入导航栏 -->
    <NaviGation_VideoClip
      @chatUpdate="handleChatUpdate"
      @aiTyping="handleAiTyping"
      @progressUpdate="handleProgressUpdate"
      @nodeUpdate="handleNodeUpdate"
      @scrollToBottom="scrollToBottom"
      :initialChatHistory="chatHistory"
    />

    <!-- 支持与反馈弹窗 -->
    <discussion-board
      class="discussion-board"
      :boardvisible="boardvisible"
      :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"
    />

    <!-- 视频裁剪浮窗 -->
    <video-trimmer-dialog
      :visible="trimmerVisible"
      :videoSrc="trimmerVideoSrc"
      @save="handleTrimmerSave"
      @cancel="handleTrimmerCancel"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import localStorageUtils from '@/utils/setLocalStorage'
import { Message, MessageBox } from 'element-ui'
import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/promptVideo'
import { ingestVideoToLibrary } from '@/utils/videoSourceIngest'
import NaviGation_VideoClip from '@/components/NaviGation_VideoClip.vue'
import VideoTrimmerDialog from '@/components/VideoTrimmerDialog.vue'
import videoClipWorkflow from '@/api/json_api/剪辑-由后期传入.json'

export default {
  name: 'VideoClip',
  components: {
    NaviGation_VideoClip,
    VideoTrimmerDialog
  },
  computed: {
    ...mapGetters(['avatar'])
  },
  data() {
    return {
      theme: true, // 主题模式
      chatHistory: [], // 对话历史
      aiTyping: false, // AI 是否正在输入
      currentProgress: '', // 当前进度
      boardvisible: false, // 支持与反馈弹窗显示状态
      disscussType: 'video_clip', // 讨论区类型
      currentNodeName: '', // 当前执行的节点名称
      videoErrors: [], // 视频加载错误信息
      trimmerVisible: false, // 视频裁剪浮窗显示状态
      trimmerVideoSrc: '' // 当前裁剪的视频URL
    }
  },
  created() {
    // 加载主题设置
    const savedTheme = localStorageUtils.getItem('theme')
    if (savedTheme !== null) {
      this.theme = savedTheme
    }
    // 先获取用户信息，再加载对话历史
    this.initUserInfoAndLoadHistory()
  },
  mounted() {
    // 滚动到底部
    this.$nextTick(() => {
      if (this.chatHistory.length > 0) {
        this.scrollToBottom()
      }
    })
  },
  methods: {
    // 初始化用户信息并加载历史
    async initUserInfoAndLoadHistory() {
      try {
        await this.$store.dispatch('morejoy_assistant/getUserInfo')
      } catch (e) {
        console.error('获取用户信息失败:', e)
      }
      this.loadChatHistory()
    },
    // 返回主页
    gohome() {
      this.$router.push({ path: '/' })
    },
    // 提示词功能
    handleScriptClick() {
      this.$router.push({ path: '/index/morejoyassistant_LLM' })
    },
    // 灵感功能（占位）
    handleInspirationClick() {
      Message.warning('o(*￣▽￣*)ブ开发者正在开发中,敬请期待😋!')
    },
    // 快捷键功能（占位）
    handleShortcutClick() {
      Message.info('快捷键说明：\nCtrl + Enter: 发送消息')
    },
    // 切换主题
    toggleTheme() {
      this.theme = !this.theme
      localStorageUtils.setItem('theme', this.theme)
      Message.success(this.theme ? '已切换到浅色模式' : '已切换到深色模式')
    },
    // 跳转到生图记录
    handleGoToImageLog() {
      const targetPath = '/userimagelog'
      if (this.$router.history.current.fullPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
    },
    // 打开支持与反馈
    handleOpenFeedback() {
      this.boardvisible = true
    },
    // 处理对话更新
    handleChatUpdate(history) {
      this.chatHistory = history
      this.saveChatHistory()
      // 裁剪后同步给子组件，保持父子历史一致
      if (this.chatHistory.length !== history.length) {
        this.$root.$emit('video-clip-sync-history', this.chatHistory)
      }
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 处理 AI 输入状态（视频剪辑不需要显示typing indicator，因为消息中已有进度）
    handleAiTyping(isTyping) {
      // 不设置 aiTyping，避免显示第二个头像
      // this.aiTyping = isTyping
      if (isTyping) {
        this.currentProgress = '' // 重置进度
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }
    },
    // 处理进度更新
    handleProgressUpdate(progress) {
      this.currentProgress = progress
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 处理视频加载错误
    handleVideoError(event, url) {
      console.error('❌ 视频加载失败:', url)
      console.error('错误事件:', event)
      console.error('错误详情:', event.target.error)
      if (event.target.error) {
        const errorCode = event.target.error.code
        const errorMap = {
          1: 'MEDIA_ERR_ABORTED - 用户终止',
          2: 'MEDIA_ERR_NETWORK - 网络错误',
          3: 'MEDIA_ERR_DECODE - 解码错误',
          4: 'MEDIA_ERR_SRC_NOT_SUPPORTED - 格式不支持'
        }
        console.error('错误码:', errorCode, '-', errorMap[errorCode] || '未知错误')
      }
      // 找到对应的slot索引
      const slotIndex = event.target.closest('.result-video-item')?.dataset?.slotIndex
      if (slotIndex !== undefined) {
        this.$set(this.videoErrors, slotIndex, `无法加载视频，URL可能无效: ${url}`)
      }
    },
    // 处理视频加载成功
    onVideoLoaded(event, url) {
      console.log('✅ 视频loadeddata:', url)
      console.log('视频尺寸:', event.target.videoWidth, 'x', event.target.videoHeight)
      console.log('视频时长:', event.target.duration, '秒')
    },
    // 视频可以播放
    onVideoCanPlay(event, url) {
      console.log('✅ 视频canplay:', url)
      console.log('视频尺寸:', event.target.videoWidth, 'x', event.target.videoHeight)
      console.log('视频时长:', event.target.duration, '秒')
    },
    // 处理节点更新
    handleNodeUpdate(nodeName) {
      this.currentNodeName = nodeName
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 滚动到底部
    scrollToBottom() {
      const container = this.$refs.chatContainer
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },
    // 加载对话历史
    loadChatHistory() {
      const userInfo = this.$store.state.morejoy_assistant?.userInfo
      if (!userInfo || !userInfo.userId) {
        return
      }
      const storageKey = `video_clip_chat_history_${userInfo.userId}`
      const savedHistory = localStorage.getItem(storageKey)
      if (savedHistory) {
        try {
          this.chatHistory = JSON.parse(savedHistory)
          console.log(`加载用户 ${userInfo.userId} 的视频剪辑对话历史:`, this.chatHistory.length, '条')
        } catch (e) {
          console.error('解析对话历史失败:', e)
          this.chatHistory = []
        }
      }
    },
    // 保存对话历史（仅保存最新10条消息，存储视频URL而非视频文件）
    saveChatHistory() {
      const userInfo = this.$store.state.morejoy_assistant?.userInfo
      if (!userInfo || !userInfo.userId) {
        return
      }
      // 限制最多保存最新10条消息
      let historyToSave = [...this.chatHistory]
      if (historyToSave.length > 10) {
        historyToSave = historyToSave.slice(-10)
        this.chatHistory = historyToSave
      }
      const storageKey = `video_clip_chat_history_${userInfo.userId}`
      localStorage.setItem(storageKey, JSON.stringify(historyToSave))
    },
    // 下载视频
    async handleDownloadVideo(video) {
      try {
        Message.info('正在下载视频...')
        const response = await fetch(video.url)
        const blob = await response.blob()
        const link = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        link.href = url
        link.download = video.name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        Message.success('视频下载成功!')
      } catch (error) {
        console.error('下载视频失败:', error)
        Message.error('下载视频失败，请稍后再试!')
      }
    },
    // 重新生成
    handleRegenerate(index) {
      if (index > 0) {
        const userMessage = this.chatHistory[index - 1]
        if (userMessage && userMessage.role === 'user') {
          // 移除失败的 AI 回复
          this.chatHistory.splice(index, 1)
          this.saveChatHistory()
          // 通过 sessionStorage 传递重新生成的参数给子组件
          const regenerateData = {
            content: userMessage.content,
            video: userMessage.video,
            videoThumbnail: userMessage.videoThumbnail
          }
          sessionStorage.setItem('video_clip_regenerate', JSON.stringify(regenerateData))
          // 通知子组件重新生成
          this.$nextTick(() => {
            this.$root.$emit('video-clip-regenerate', regenerateData)
          })
        }
      }
    },
    // 一键填入：将对应用户消息的提示词和视频填回输入框
    handleRefill(index) {
      // AI 消息的前一条就是对应的用户消息
      if (index > 0) {
        const userMessage = this.chatHistory[index - 1]
        if (userMessage && userMessage.role === 'user') {
          const refillData = {
            content: userMessage.content,
            video: userMessage.video,
            videoThumbnail: userMessage.videoThumbnail
          }
          this.$root.$emit('video-clip-refill', refillData)
          Message.success('已填入提示词和视频')
        }
      }
    },
    // 加入素材库：确认后将视频URL传入Qwen3.5-Omni视频反推工作流进行分析
    async handleAddToMaterial(video) {
      if (!video || !video.url) {
        Message.warning('视频URL不存在，无法加入素材库')
        return
      }
      try {
        await MessageBox.confirm(
          '确认此条视频素材无误，添加到视频素材库',
          '加入素材库',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }
        )
      } catch {
        // 用户点击取消，不执行后续操作
        return
      }
      // 提交反推工作流 → 轮询 node19 结果 → 入库（Route A：前端中转，复用登录态）
      // 分析耗时较长，采用后台轮询 + 消息通知，不阻塞页面其他操作
      let submitted = false
      try {
        await ingestVideoToLibrary(video.url, {
          onProgress: (stage) => {
            if (stage === 'submitted' && !submitted) {
              submitted = true
              Message.info('已提交分析，完成后将自动入库（请保持页面开启）')
            }
          }
        })
        Message.success('视频已成功入库素材库')
      } catch (error) {
        console.error('加入素材库失败:', error)
        Message.error('加入素材库失败：' + (error.message || '请稍后再试'))
      }
    },
    // 后期处理：打开视频裁剪浮窗
    handlePostProcess(video) {
      if (!video || !video.url) {
        Message.warning('视频URL不存在，无法进行后期处理')
        return
      }
      this.trimmerVideoSrc = video.url
      this.trimmerVisible = true
    },
    // 裁剪保存：构造 clip_json 并提交剪辑工作流
    async handleTrimmerSave(trimData) {
      console.log('[VideoClip] handleTrimmerSave 被调用，收到数据:', trimData)
      try {
        Message.info('正在提交视频剪辑任务...')

        // 构造 clip_json 字符串，格式严格为: {endTime: <number>,\nstartTime: <number>,\nvideoSrc: '<url>'}
        const clipJsonStr = `{endTime: ${trimData.endTime},\nstartTime: ${trimData.startTime},\nvideoSrc: '${trimData.videoSrc}'}`
        console.log('[VideoClip] clip_json 构造完成:', clipJsonStr)

        const workflowCopy = JSON.parse(JSON.stringify(videoClipWorkflow))
        workflowCopy['1'].inputs.clip_json = clipJsonStr
        workflowCopy['2'].inputs.filename_prefix = `vidi_clip_${Date.now()}`
        console.log('[VideoClip] 工作流替换完成，node1.clip_json:', workflowCopy['1'].inputs.clip_json)
        console.log('[VideoClip] 工作流替换完成，node2.filename_prefix:', workflowCopy['2'].inputs.filename_prefix)

        const clientId = uuidv4()
        const data = {
          prompt: workflowCopy,
          client_id: clientId
        }
        console.log('[VideoClip] 完整请求体:', JSON.stringify(data, null, 2))

        const result = await genPrompt(data)
        console.log('[VideoClip] genPrompt 返回结果:', result)
        console.log('[VideoClip] node_errors 详情:', JSON.stringify(result?.node_errors, null, 2))

        if (result && result.prompt_id) {
          console.log('✅ 视频剪辑任务提交成功，promptId:', result.prompt_id)
          Message.success('视频剪辑任务已提交，处理完成后将自动入库')
        } else {
          console.error('[VideoClip] genPrompt 返回数据无 prompt_id:', result)
          throw new Error('任务提交失败: 响应中无 prompt_id')
        }
        this.trimmerVisible = false
      } catch (error) {
        console.error('[VideoClip] 视频剪辑提交失败，错误详情:', {
          message: error.message,
          code: error.code,
          response: error.response?.data,
          status: error.response?.status
        })
        Message.error(`视频剪辑提交失败: ${error.message || '未知错误'}，请稍后再试`)
      }
    },
    // 裁剪取消
    handleTrimmerCancel() {
      this.trimmerVisible = false
    },
    // 格式化时间（用于裁剪结果显示）
    formatTime(seconds) {
      if (!seconds || isNaN(seconds)) return '00:00.0'
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      const ms = Math.floor((seconds % 1) * 10)
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}.${ms}`
    },
    // 一键填入：从videoSlots中填入单个视频
    handleRefillWithVideo(video, aiMessage, slotIndex) {
      // 找到对应的用户消息（AI消息的前一条）
      const aiIndex = this.chatHistory.findIndex(msg => msg === aiMessage)
      if (aiIndex > 0) {
        const userMessage = this.chatHistory[aiIndex - 1]
        if (userMessage && userMessage.role === 'user') {
          // 如果用户消息有多个视频，取对应索引的视频
          const userVideo = userMessage.videos && userMessage.videos[slotIndex]
            ? userMessage.videos[slotIndex]
            : userMessage.video // 兼容旧格式
          const refillData = {
            content: userMessage.content,
            video: userVideo ? userVideo.url : video.url,
            videoThumbnail: userVideo ? userVideo.thumbnail : ''
          }
          this.$root.$emit('video-clip-refill', refillData)
          Message.success('已填入提示词和视频')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

// 页面最外层容器
.video-clip-container {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: white;
  overflow: hidden;
}

// 顶部 header
header {
  height: 95px;
  width: 100%;
  padding: 10px 30px;
  font-family: "icomoon";
  font-size: 18px;
  border-bottom: 1px solid #e5e7eb;
  background: white;

  .header-content {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .logo-section {
    width: 230px;
    height: 75px;
    display: flex;
    align-items: center;
    padding: 10px;

    img {
      width: 230px;
      object-fit: cover;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .header-spacer {
    flex: 1;
  }

  .header-actions {
    display: flex;
    gap: 20px;
    align-items: center;

    .home-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: #ff8c42;
      color: white;
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        background-color: #ff7a2e;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }
    }

    .header-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: rgba(39, 41, 46, 0.05);
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      color: #333;
      white-space: nowrap;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        background-color: #f0f0f0;
        transform: translateY(-2px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      }
    }

    .user-avatar {
      display: flex;
      width: 50px;
      height: 50px;
      border: 2px solid #e5e7eb;
      border-radius: 50%;
      overflow: hidden;
      justify-content: center;
      align-items: center;

      img {
        cursor: pointer;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}

// 内容区域包裹器
.video-clip-page-wrapper {
  display: flex;
  width: 100vw;
  height: calc(100vh - 95px);
  overflow: hidden;
}

// 左侧精简导航栏
.slim-sidebar {
  width: 80px;
  height: calc(100vh - 95px);
  background: white;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;

  .sidebar-middle {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: center;
    justify-content: center;
  }

  .sidebar-bottom {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 12px 0;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 8px;
    width: 60px;

    .iconfont {
      font-size: 24px;
      color: #666;
      transition: all 0.3s;
    }

    .nav-icon {
      width: 24px;
      height: 24px;
      color: #666;
      transition: all 0.3s;
    }

    .nav-label {
      font-size: 12px;
      color: #999;
      transition: all 0.3s;
    }

    &:hover {
      background: #f5f7fa;

      .iconfont {
        color: @morejoy;
      }

      .nav-icon {
        color: @morejoy;
      }

      .nav-label {
        color: @morejoy;
      }
    }
  }
}

.right_menu_assistant {
  flex: 1;
  height: calc(100vh - 95px);
  display: flex;
  flex-direction: column;
  background: white;
  overflow: hidden;
  position: relative;
}

// 对话容器
.chat-container {
  flex: 1;
  overflow-y: auto;
  padding: 30px 40px;
  padding-bottom: 250px;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: @basicselect;
    border-radius: 3px;

    &:hover {
      background: @morejoy;
    }
  }
}

// 对话历史
.chat-history {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

// 消息项
.message-item {
  display: flex;
  animation: fadeIn 0.3s ease;

  &.user-message {
    justify-content: flex-end;
  }

  &.ai-message {
    justify-content: flex-start;
  }
}

// AI消息列式容器（气泡 + 气泡外下方按钮）
.message-item-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 75%;

  // 拆分模式：占满对话列宽，使横向片段窗口左右缘与头像外缘对齐，滚动条收敛在窗口内部
  &.split-column {
    max-width: 100%;
    width: 100%;

    // 允许 flex 子项收缩，避免 nowrap 行撑破外层导致页面级横向滚动条
    .message-wrapper {
      max-width: 100%;
      width: 100%;
      min-width: 0;
    }

    .message-content {
      min-width: 0;
    }

    // 窗口左缘回退到 AI 头像左缘（头像45 + gap15 = 60），右缘即对话列右缘（用户头像右缘）
    .message-videos.split-row {
      width: calc(100% + 60px);
      margin-left: -60px;
      max-width: none;
    }
  }
}

// 气泡下方操作按钮（独立于气泡外，靠右对齐气泡右边缘）
.video-extra-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;

  .extra-actions-group {
    display: flex;
    gap: 8px;
  }

  .extra-action-btn {
    padding: 6px 14px;
    border: 1px solid @morejoy;
    background: @morejoy;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    color: white;
    transition: all 0.3s;

    &:hover {
      background: #ff7a2e;
      border-color: #ff7a2e;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-wrapper {
  display: flex;
  gap: 15px;
  max-width: 75%;
}

.message-avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &.ai-avatar {
    background: linear-gradient(135deg, @morejoy 0%, #ff7a2e 100%);
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
      font-size: 24px;
      color: white;
    }
  }
}

.message-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 缩略图容器
.message-thumbnails {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-right: 12px;
  flex-shrink: 0;
  align-items: flex-start;

  .video-thumbnail {
    width: 60px;
    height: 60px;
    border-radius: 8px;
    background: linear-gradient(135deg, @morejoy 0%, #ff7a2e 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    overflow: hidden;

    .thumbnail-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .iconfont {
      font-size: 28px;
      color: white;
    }
  }
}

.user-message .message-text {
  background: @morejoy;
  color: white;
  padding: 15px 20px;
  border-radius: 18px 18px 4px 18px;
  font-size: 16px;
  line-height: 1.6;
  word-wrap: break-word;
}

.ai-message .message-text {
  background: white;
  color: #333;
  padding: 15px 20px;
  border-radius: 18px 18px 18px 4px;
  font-size: 16px;
  line-height: 1.6;
  word-wrap: break-word;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  &.error {
    background: rgba(245, 108, 108, 0.1);
    border: 2px solid rgba(245, 108, 108, 0.5);
    color: rgb(245, 108, 108);
  }
}

// 视频结果展示区域

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

// 批量视频槽位容器
.message-videos {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 12px;

  // 视频拆分模式：所有片段一字排开，超出显示范围横向滚动
  &.split-row {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100%;
    padding-bottom: 10px;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f2f3f5;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: @morejoy;
      border-radius: 4px;

      &:hover {
        background: #ff7a2e;
      }
    }
  }
}

// 视频槽位项
.result-video-item {
  width: 320px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  flex-shrink: 0;
  // 固定高度，确保loading和done状态尺寸一致（容纳4个操作按钮的2×2布局）
  height: 300px;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  // 加载中占位框
  &.placeholder-item {
    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;

    &:hover {
      transform: none;
    }

    .placeholder-animation {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 12px;
      }
    }
  }

  // 完成状态
  .result-video-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .result-video {
      width: 100%;
      flex: 1;
      min-height: 150px;
      border-radius: 12px 12px 0 0;
      display: block;
      object-fit: cover;
      background: #000;
    }

    .video-actions {
      padding: 12px;
      background: white;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      border-top: 1px solid #f0f0f0;
      flex-shrink: 0;

      .action-btn {
        flex: 1 1 calc(50% - 4px);
        padding: 8px 10px;
        border: 1px solid #e0e0e0;
        background: white;
        border-radius: 6px;
        cursor: pointer;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        transition: all 0.3s;
        white-space: nowrap;

        &:hover {
          background: @morejoy;
          color: white;
          border-color: @morejoy;
        }

        .iconfont {
          font-size: 16px;
        }
      }
    }

    .video-error {
      padding: 10px;
      background: #fff3cd;
      border: 1px solid #ffc107;
      border-radius: 0 0 12px 12px;
      color: #856404;
      font-size: 12px;
      flex-shrink: 0;

      p {
        margin: 4px 0;
        word-break: break-all;
      }
    }
  }

  // 错误状态
  &.error-item {
    background: rgba(245, 108, 108, 0.08);
    border: 2px dashed rgba(245, 108, 108, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;

    &:hover {
      transform: none;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    }

    .error-placeholder {
      display: flex;
      align-items: center;
      justify-content: center;

      .error-icon {
        font-size: 32px;
        color: #f56c6c;
        font-weight: bold;
      }
    }
  }
}

// 调试信息样式
.debug-info {
  padding: 20px;
  background: #fff3cd;
  border: 2px solid #ffc107;
  border-radius: 12px;
  color: #856404;
  font-size: 12px;
  p {
    margin: 5px 0;
    word-break: break-all;
  }
}

// 单个视频结果（旧版兼容）
.message-video {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  background: white;

  .result-video {
    width: 100%;
    max-width: 480px;
    border-radius: 12px 12px 0 0;
    display: block;
  }

  .video-actions {
    padding: 12px;
    background: white;
    display: flex;
    gap: 10px;
    justify-content: flex-end;

    .action-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 8px 16px;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s;
      font-size: 14px;

      .iconfont {
        font-size: 16px;
      }

      &.download-btn {
        background: @morejoy;
        color: white;

        &:hover {
          background: #ff7a2e;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(255, 140, 66, 0.3);
        }
      }

      &.refill-btn {
        background: #bfbfbf;
        color: white;

        &:hover {
          background: #c2c2c2;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
        }
      }
    }
  }
}

// 消息按钮组
.message-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  width: 100%;
  flex-basis: 100%;

  .action-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: white;
    color: #666;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;

    &:hover {
      background: #fff8f3;
      color: @morejoy;
      border-color: @morejoy;
    }

    &.regenerate-btn {
      &:hover {
        background: @morejoy;
        color: white;
        border-color: @morejoy;
      }
    }
  }
}

// 空状态
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;

  .empty-icon {
    font-size: 80px;
    margin-bottom: 20px;
    opacity: 0.5;
  }

  h3 {
    font-size: 24px;
    font-weight: 600;
    color: #666;
    margin: 0 0 10px 0;
  }

  p {
    font-size: 16px;
    color: #999;
    margin: 0;
  }
}

// AI 输入提示
.typing-indicator {
  display: flex;
  gap: 15px;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  animation: fadeIn 0.3s ease;

  .typing-avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: linear-gradient(135deg, @morejoy 0%, #ff7a2e 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .iconfont {
      font-size: 24px;
      color: white;
    }
  }

  .typing-content {
    display: flex;
    flex-direction: column;
    gap: 6px;

    .typing-dots {
      display: flex;
      gap: 6px;
      padding: 15px 20px;
      background: white;
      border-radius: 18px 18px 18px 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

      span {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: @morejoy;
        animation: typing 1.4s infinite;

        &:nth-child(2) {
          animation-delay: 0.2s;
        }

        &:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }

    .node-executing {
      padding: 15px 25px;
      background: white;
      border-radius: 18px 18px 18px 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      .node-name {
        font-size: 13px;
        color: #999;
        font-weight: 400;
        animation: breathe 2s ease-in-out infinite;
        display: inline-block;
      }
    }
    .progress-text {
      font-size: 14px;
      color: #999;
      text-align: center;
    }
  }
}

@keyframes typing {
  0%, 60%, 100% {
    opacity: 0.3;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-10px);
  }
}

@keyframes breathe {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}
</style>
